import { Typography as e } from "../../Typography/Typography.mjs";
import { Icons as t } from "../Icons/Icons.mjs";
import { Box as n } from "../Primitives/Box.mjs";
import { VStack as r } from "../Primitives/Stack.mjs";
import { useState as i } from "react";
import { styled as a } from "styled-components";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/Collapsible/Collapsible.tsx
var c = a(n)``, l = a.button`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme: e }) => e.colors.foreground};

    &:hover {
        opacity: 0.8;
    }
`, u = a.div`
    display: grid;
    grid-template-rows: ${({ $isOpen: e }) => e ? "1fr" : "0fr"};
    transition: grid-template-rows ${({ theme: e }) => e.transitions.normal} ease-in-out;

    > div {
        overflow: hidden;
    }
`, d = ({ title: a, children: d, defaultOpen: f = !1, open: p, onOpenChange: m, className: h }) => {
	let [g, _] = i(f), v = p !== void 0, y = v ? p : g;
	return /* @__PURE__ */ o(c, {
		className: h,
		children: /* @__PURE__ */ s(r, {
			gap: y ? 2 : 0,
			children: [/* @__PURE__ */ s(l, {
				type: "button",
				onClick: () => {
					let e = !y;
					v || _(e), m?.(e);
				},
				"aria-expanded": y,
				children: [/* @__PURE__ */ o(e, {
					variant: "h6",
					weight: "medium",
					children: a
				}), /* @__PURE__ */ o(n, {
					style: {
						transform: y ? "rotate(180deg)" : "rotate(0deg)",
						transition: "transform 0.2s ease"
					},
					children: /* @__PURE__ */ o(t.ChevronDown, { size: 20 })
				})]
			}), /* @__PURE__ */ o(u, {
				$isOpen: y,
				children: /* @__PURE__ */ o(n, { children: d })
			})]
		})
	});
};
//#endregion
export { d as Collapsible };
